import React, { createContext, useContext, useState, useEffect } from "react";

// Create the context
export const LocationContext = createContext();

// Custom hook to use the LocationContext
export const useDefLocation = () => useContext(LocationContext);

// LocationContext Provider
export const LocationProvider = ({ children }) => {
  const [defaultLocation, setDefaultLocation] = useState(
    localStorage.getItem("defaultLocation") || ""
  );

  // Update localStorage whenever defaultLocation changes
  useEffect(() => {
    if (defaultLocation) {
      localStorage.setItem("defaultLocation", defaultLocation);
    }
  }, [defaultLocation]);

  const value = { defaultLocation, setDefaultLocation };

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};
